var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('HeroHeader'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container-narrow wizard-shell"},[_c('div',{staticClass:"sponsor-capture"},[_c('div',{staticClass:"sponsor-capture__spinner",attrs:{"aria-hidden":"true"}}),_c('p',{staticClass:"sponsor-capture__text"},[_vm._v("Carregando...")])])])
}]

export { render, staticRenderFns }